module.exports = __webpack_public_path__ + "static/media/igi_auction_volume_reserve.9e62f39d.png";